import { API } from '../Api';
import { AlertStyle } from '../../utils/alert-style';
import { AlertVolumes } from '../../utils/overlay-volume';

/** Phản hồi giao diện thông báo kèm âm lượng trên OBS (máy chủ cũ có thể chưa trả hai trường âm lượng). */
export type AlertStyleResponse = AlertStyle & Partial<AlertVolumes>;

// Giao diện thông báo donate trên OBS (payment-service). Chưa cài thì BE trả mặc định, isDefault = true.
// Bên gọi nên chạy normalizeAlertStyle() trên kết quả trước khi dùng.

export const getMyAlertStyle = () =>
  API.get<AlertStyleResponse>('/v1/payment-service/donate-alert-style/me').then((r) => r.data);

export const saveAlertStyle = (s: AlertStyle) =>
  API.post<AlertStyle>('/v1/payment-service/donate-alert-style', {
    layout: s.layout,
    position: s.position,
    textSize: s.textSize,
    animation: s.animation,
    cardColor: s.cardColor,
    cardOpacity: Math.round(s.cardOpacity),
  }).then((r) => r.data);

// Công khai — overlay OBS đọc được không cần đăng nhập.
export const getPublicAlertStyle = (userId: string) =>
  API.get<AlertStyleResponse>('/v1/payment-service/public/creator-alert-style', {
    params: { userId },
  }).then((r) => r.data);

// Lưu riêng âm lượng trên OBS (0–100), không đụng giao diện. Máy chủ kẹp số ngoài khoảng.
export const saveAlertVolume = (v: AlertVolumes) =>
  API.post<AlertStyleResponse>('/v1/payment-service/donate-alert-style/volume', {
    alertVolume: Math.round(v.alertVolume),
    voiceVolume: Math.round(v.voiceVolume),
  }).then((r) => r.data);
